import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        m4backuparr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_M4BACKUPLIST: (state, obj) => {

            state.total = obj.total
            state.m4backuparr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.m4backuparr.splice(index,1)
        },
        CLEAR_M4BACKUPLIST: (state) => {

            state.total = 0
            state.m4backuparr=[]

        },


    },
    actions: {
        async getM4backuplist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getm4backuplist(params)
            if (code == 200) {
                commit('SET_M4BACKUPLIST', data);
           
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}